import React from "react";
import NavBar from "../components/Nav";
import BackTop from "../components/BackToTop";
import Footer from "../components/Footer";
import GoToTop from "../components/Top";
import img1 from "../assets/images/muyi.jpg";
import img13 from "../assets/images/dims.jpeg";
import img11 from "../assets/images/majesty.jpeg";
import img12 from "../assets/images/evelyn.jpeg";

function About() {
  const boardMembers = [
    { name: "MAJESTY IWODI", image: img11, role: "Board Member" },
    { name: "OLADIMEJI OGUN", image: img13, role: "Board Member" },
    { name: "MUYIDEEN OYELEKE", image: img1, role: "Board Member" },
    { name: "EVELYN AKENBOR", image: img12, role: "Board Member" },
  ];

  const executiveMembers = [
    { name: "MAJESTY IWODI", image: img11, role: "MD/CEO" },
    { name: "OLADIMEJI OGUN", image: img13, role: "Director Finance & Admin" },
    {
      name: "MUYIDEEN OYELEKE",
      image: img1,
      role: "Director Business Development",
    },
  ];

  return (
    <>
      <div className="container-fluid px-3 about-page-wrap">
        <title>About RoyalMines Property</title>
        <meta
          name="description"
          content="Find the best real estate and properties in Abuja and Nigeria. Explore a wide range of residential and commercial properties, including houses, apartments, land, and more. Discover trusted real estate agents, listings, and resources to help you buy, sell, or rent properties in Abuja and across Nigeria."
        />
        <meta
          name="keywords"
          content="real estate, properties, Abuja, Nigeria, houses, apartments, land, mortgages, mortgage, real estate agents, listings, buy, sell, rent, residential, commercial, apartments, houses, land, real estate solutions, real estate company"
        />

        <NavBar about={"active"} />
        <BackTop />

        <div className="container-xxl py-5 about-modern-page">
          <div className="container">
            <header className="about-header text-center about-modern-hero">
              <div
                className="mb-5 wow fadeInUp"
                data-wow-delay="0.1s"
                style={{ maxWidth: "600px", margin: "0 auto" }}
              >
                <span className="properties-kicker">Who we are</span>
                <h1 className="mb-3">About Us</h1>
                <p className="mb-0">
                  A dedicated and diverse group of professionals united by a
                  passion for excellence. Get to know the individuals driving
                  our company forward, each bringing unique expertise and
                  perspectives to our collaborative efforts. Together, we strive
                  to deliver exceptional results and unparalleled service to our
                  clients.
                </p>
              </div>
            </header>

            <section className="about-pillars-section">
              <div className="row g-4">
                <div className="col-lg-6">
                  <article className="about-pillar-card h-100 wow fadeInDown" data-wow-delay="0.1s">
                    <span className="about-pillar-label">Our Mission</span>
                    <p>
                      Our mission is to lead Nigeria's real estate and mortgage
                      sector with trust and technology, delivering seamless
                      solutions and empowering dreams through comprehensive real
                      estate solutions.
                    </p>
                  </article>
                </div>
                <div className="col-lg-6">
                  <article className="about-pillar-card h-100 wow fadeInDown" data-wow-delay="0.2s">
                    <span className="about-pillar-label">Our Vision</span>
                    <p>
                      To be the pioneering force, shaping Nigeria's real estate
                      and mortgage landscape through innovative technology and
                      unwavering integrity. We achieve this by driving
                      transformative solutions and prioritizing the aspirations
                      of all stakeholders, with a commitment to Professionalism,
                      Resilience, Empathy and Value creation.
                    </p>
                  </article>
                </div>
              </div>
            </section>

            <section className="about-content-grid mt-4">
              <article className="about-content-card wow fadeInUp" data-wow-delay="0.1s">
                <h2>Who We Are</h2>
                <p>
                  Royalmines Property Limited was incorporated on the 10th day
                  of October 2014 as a Limited Liability company. The company
                  was principally incorporated to carry on the business as
                  developers of estate and property of any description. The
                  company has been at the centre of the real estate business in
                  the Federal Capital Territory. It has developed properties in
                  the city of Abuja and also partners with established real
                  estate companies to provide high quality and affordable
                  properties for clients.
                </p>
                <p>
                  Royalmine is blessed with several professionals with combined
                  work experience of more than 100 years, positioning the
                  company as a strong emerging real estate firm. We operate by
                  systematically evaluating every detail of our clients’
                  interests, increasing value and comfort while offering
                  dependable after-sales service.
                </p>
                <p>
                  We also provide good and cutting-edge refreshment services at
                  affordable prices, delivered in an executive manner with high
                  professionalism and courtesy.
                </p>
                <h3 className="about-subtitle">Projects we have delivered</h3>
                <ul className="about-list">
                  <li>Construction of drainages</li>
                  <li>Building of shopping malls</li>
                  <li>Building of private residences</li>
                  <li>Building of estates</li>
                  <li>Rehabilitation works</li>
                </ul>
              </article>

              <article className="about-content-card about-service-card wow fadeInUp" data-wow-delay="0.2s">
                <h2>Our Services</h2>
                <p>Our services include:</p>
                <ul className="about-list about-service-list">
                  <li>Real Estate</li>
                  <li>Information Communication Technology</li>
                  <li>Agro Allied</li>
                  <li>Food and Hospitality Management</li>
                  <li>Oil and Gas</li>
                  <li>Property Developer / Management</li>
                  <li>Construction / Civil work</li>
                  <li>Electrical Engineering and Rural Electrification</li>
                  <li>General Engineering Design and Consultancy</li>
                  <li>Financial Aid</li>
                  <li>Merchandise / General Contractor</li>
                </ul>
              </article>

              <article className="about-content-card wow fadeInUp" data-wow-delay="0.3s">
                <h2>Management Team</h2>
                <p>
                  Our management team combines deep industry experience,
                  operational discipline, and people-first leadership to keep
                  every project aligned with quality and client outcomes.
                </p>
                <p>
                  We continue to evolve through innovation and accountability,
                  creating sustainable value for home buyers, investors, and
                  communities.
                </p>
              </article>
            </section>

            <section className="team-section mt-5">
              <div className="text-center mb-4">
                <span className="properties-kicker">Leadership</span>
                <h2 className="my-2">Meet Our Team</h2>
              </div>

              <div className="team-group mb-5">
                <h3 className="mb-4 text-center">Board of Directors</h3>
                <div className="row g-4 team">
                  {boardMembers.map((member, index) => (
                    <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s" key={`${member.name}-${index}`}>
                      <article className="team-item team-card-modern rounded overflow-hidden h-100">
                        <div className="position-relative team-media">
                          <img className="img-fluid" src={member.image} alt={member.name} />
                          <div className="text-center p-4 team-overlay-content">
                            <h5 className="fw-bold mb-1">{member.name}</h5>
                            <small>{member.role}</small>
                          </div>
                        </div>
                      </article>
                    </div>
                  ))}
                </div>
              </div>

              <div className="team-group">
                <h3 className="mb-4 text-center">Executive Members</h3>
                <div className="row g-4 team justify-content-center">
                  {executiveMembers.map((member, index) => (
                    <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s" key={`${member.name}-${member.role}-${index}`}>
                      <article className="team-item team-card-modern rounded overflow-hidden h-100">
                        <div className="position-relative team-media">
                          <img className="img-fluid" src={member.image} alt={member.name} />
                          <div className="text-center p-4 team-overlay-content">
                            <h5 className="fw-bold mb-1">{member.name}</h5>
                            <small>{member.role}</small>
                          </div>
                        </div>
                      </article>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          </div>
        </div>

        <div>
          <Footer />
        </div>
      </div>
      <GoToTop />
    </>
  );
}

export default About;
